module.exports = __webpack_public_path__ + "img/arrow@3x.e46e019b.png";